import { BaseRestDataProvider } from './BaseRestDataProvider';
import { Customer } from '../models/Customer';

export class CustomerRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/customers');
  }

  getAll(): Promise<Customer[]> {
    return this.get<Customer[]>(``);
  }

  getById(id: string): Promise<Customer> {
    return this.get<Customer>(`/${id}`);
  }

  add(customer: Customer): Promise<Customer> {
    return this.post<Customer>(``, customer);
  }

  update(id: string, customer: Customer): Promise<void> {
    return this.put<void>(`/${id}`, customer);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { Customer };
